// extracted by mini-css-extract-plugin
module.exports = {"createButton":"HomePage_createButton__2C7Sd","createBox":"HomePage_createBox__2XZfU"};